export const dataProperties = {
  aboutUs: 'aboutUs',
  businessSummary: 'businessSummary',
};

export const placeholderValues = {
  [dataProperties.aboutUs]: _TL_('About Us'),
  [dataProperties.businessSummary]: _TL_('Tell customers about what sets your business apart'),
};

